document.addEventListener('DOMContentLoaded', function() {
  var track = document.querySelector('.marquee-track');
  var wrapper = document.querySelector('.marquee-wrapper');
  
  // Clone all items for infinite loop
  var items = track.innerHTML;
  track.innerHTML = items + items;
    
  var itemCount = track.querySelectorAll('.marquee-item').length;
  var duration = 20;
    
  track.style.animationDuration = duration + 's';
    
  // wrapper.addEventListener('mouseenter', function() {
  //   track.style.animationPlayState = 'paused';
  // });
  
  // wrapper.addEventListener('mouseleave', function() {
  //   track.style.animationPlayState = 'running';
  // });
});